import React from 'react';
import { Button } from '@mui/material';
import { panelTheme } from '../PanelComerciales.theme';

/**
 * Pie de los drawers de VIP (asignar y editar): muestra el mensaje de error
 * y los botones Cancelar/Submit. Centralizar evita repetir el mismo bloque
 * de estilos y estructura en cada drawer.
 */
interface VipDrawerActionsProps {
    error: string | null;
    submitLabel: string;
    onCancel: () => void;
    onSubmit: () => void;
}

const VipDrawerActions: React.FC<VipDrawerActionsProps> = ({
    error,
    submitLabel,
    onCancel,
    onSubmit,
}) => (
    <>
        {error ? (
            <span style={{ color: panelTheme.colors.danger, fontSize: 12 }}>{error}</span>
        ) : null}
        <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
            <Button onClick={onCancel} sx={{ textTransform: 'none' }}>
                Cancelar
            </Button>
            <Button
                onClick={onSubmit}
                variant='contained'
                sx={{
                    textTransform: 'none',
                    background: panelTheme.colors.indigo,
                    '&:hover': { background: panelTheme.colors.violet },
                }}
            >
                {submitLabel}
            </Button>
        </div>
    </>
);

export default VipDrawerActions;
